import { useMemo } from 'react';

import { mergeSyncTypeStatus, useSyncRecordStatusSubscription } from './persistence';

import { useScanDataSyncModel, useScanNoteSyncModel, useScanPhotoSyncModel } from './Models';
import { useScanSynchronizer } from './ScanSynchronizer';

/**
 * Utility hook to get sync progress for a scan
 * @param scanId - optional: if provided, will only return progress for the scan ID, otherwise will return progress for all scans
 * @returns The sync progress for the scan
 */
export const useSyncStatus = (scanId?: string) => {
  const scanDataSyncStatus = useSyncRecordStatusSubscription(useScanDataSyncModel(), scanId);
  const photosSyncStatus = useSyncRecordStatusSubscription(useScanPhotoSyncModel(), scanId);
  const notesSyncStatus = useSyncRecordStatusSubscription(useScanNoteSyncModel(), scanId);
  const { stats } = useScanSynchronizer();

  return useMemo(() => ({
    errors: stats.errors,
    scanDataSyncStatus,
    photosSyncStatus,
    notesSyncStatus,
    syncStatus: mergeSyncTypeStatus([scanDataSyncStatus, photosSyncStatus, notesSyncStatus]),
  }), [scanDataSyncStatus, photosSyncStatus, notesSyncStatus, stats.errors]);
};
